module.exports = __webpack_public_path__ + "img/file-type-music-alt.7d5cccf1.svg";